<template>
  <div id="toast" class="toast toast-show" :class="{'show':toastShow}">{{toastMsg}}</div>
</template>
<style>
  .toast.show{
    display: block;
  }
  .toast{
    width: 70%;
    height: 40px;
    background: rgba(0,0,0,0.68);
    border-radius: 8px;
    position: absolute;
    top:300px;
    left:15%;
    text-align: center;
    line-height: 40px;
    color: #efefef;
    display: none;
  }
  .toast-show{
    -webkit-animation: toast-d-u 3s 1 ease-in-out;
    -moz-animation: toast-d-u 3s 1 ease-in-out;
    -o-animation: toast-d-u 3s 1 ease-in-out;
    animation: toast-d-u 3s 1 ease-in-out;
    -webkit-animation-fill-mode:forwards;
    -moz-animation-fill-mode:forwards;
    -o-animation-fill-mode:forwards;
    animation-fill-mode:forwards;
  }
  @-webkit-keyframes toast-d-u {
    0% {opacity: 0;}
    30% {opacity: 1;}
    70% {opacity: 1;}
    100% {opacity: 0;}
  }
  @-moz-keyframes toast-d-u {
    0% {opacity: 0;}
    30% {opacity: 1;}
    70% {opacity: 1;}
    100% {opacity: 0;}
  }
  @-o-keyframes toast-d-u {
    0% {opacity: 0;}
    30% {opacity: 1;}
    70% {opacity: 1;}
    100% {opacity: 0;}
  }
  @keyframes toast-d-u {
    0% {opacity: 0;}
    30% {opacity: 1;}
    70% {opacity: 1;}
    100% {opacity: 0;}
  }
</style>
<script>
  export default {
    data () {
      return {
        toastMsg: '',
        toastShow: false,
        setTimeOutObj: null
      }
    },
    watch: {
      toastShow (newValue) {
        if (newValue === true) {
          var that = this
          that.setTimeOutObj = setTimeout(function () {
            that.toastShow = false
          }, 3000)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// toast.vue?49d6d368